import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const ChapterPrevious = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="ChapterPrevious" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M3 10.7637L13.4121 3.19141C13.7163 2.97026 14.119 2.93774 14.4541 3.1084C14.7892 3.27909 15 3.6239 15 4V8.04395L22.4141 2.68945C22.7184 2.46964 23.1208 2.43855 23.4551 2.60938C23.7894 2.78034 24 3.12447 24 3.5V20C24 20.3688 23.7968 20.7078 23.4717 20.8818C23.1466 21.0557 22.7521 21.0366 22.4453 20.832L15 15.8682V20C15 20.3761 14.7892 20.7209 14.4541 20.8916C14.119 21.0623 13.7163 21.0297 13.4121 20.8086L3 13.2354V22H1V2H3V10.7637ZM14.5859 10.8105C14.2816 11.0304 13.8792 11.0614 13.5449 10.8906C13.2106 10.7197 13 10.3755 13 10V5.96289L4.69922 12L13 18.0361V14C13 13.6312 13.2032 13.2922 13.5283 13.1182C13.8534 12.9443 14.2479 12.9634 14.5547 13.168L22 18.1309V5.45508L14.5859 10.8105Z" fill="#000" />
  </StyledIcon>
));

ChapterPrevious.displayName = 'ChapterPrevious';

export { ChapterPrevious };
